import { connect } from 'react-redux';
import { ApplicationState } from '../../../../store';
import PersonalQPage7, { IProps } from './index';
import { InputFieldConfig } from '../../../../types';
import { getPageStatus } from './utils';

const mapStateToProps = (state: ApplicationState): IProps => {
  const {
    PassportStatus: passportStatusConfig,
    PassportNumber: passportNumberConfig,
    PassportExpectedDate: passportExpectedDateConfig,
    PassportExpiryDate: passportExpiryDateConfig,
  }: {
    PassportStatus: InputFieldConfig;
    PassportNumber: InputFieldConfig;
    PassportExpectedDate: InputFieldConfig;
    PassportExpiryDate: InputFieldConfig;
  } = state.student.config.Checklist.PersonalInfo.Page7;
  const {
    passportStatus = passportStatusConfig?.defaultValue as string | undefined,
    passportNumber = passportNumberConfig?.defaultValue as string | undefined,
    passportExpectedDate = passportExpectedDateConfig?.defaultValue as string | undefined,
    passportExpiryDate = passportExpiryDateConfig?.defaultValue as string | undefined,
  } = state.student.personalInfo;
  const { complete, visible } = getPageStatus(state.student.config, {
    passportStatus,
    passportNumber,
    passportExpectedDate,
    passportExpiryDate,
  });

  const {
    passportStatus: passportStatusVisible,
    passportNumber: passportNumberVisible,
    passportExpectedDate: passportExpectedDateVisible,
    passportExpiryDate: passportExpiryDateVisible,
  } = visible;

  return {
    sectionTitle: state.student.config.Checklist.PersonalInfo.shortTitle,
    complete,
    currentStep: 7,
    steps: 10,
    passportNumber,
    passportNumberVisible,
    passportNumberConfig,
    passportStatus,
    passportStatusVisible,
    passportStatusConfig,
    passportExpectedDate,
    passportExpectedDateVisible,
    passportExpectedDateConfig,
    passportExpiryDate,
    passportExpiryDateVisible,
    passportExpiryDateConfig,
    config: state.student.config,
    isPageComplete: state.student.offer.isPIPage7Complete,
    importData: state.student.importData,
  };
};

export default connect(mapStateToProps)(PersonalQPage7);
